import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { comedorStockApi } from '../../services/api'

// Ventana flotante con las alertas del stock de comedores: mercadería vencida, por vencer (30 días) y
// remitos sin firmar. Aparece sola para quienes administran comedores (permiso comedores_admin) al entrar
// al sistema; "Más tarde" la oculta hasta la próxima sesión y "Ver stock" lleva a la planilla.
const CLAVE = 'alertaStockOculta'
const leer = () => { try { return sessionStorage.getItem(CLAVE) === '1' } catch { return false } }
const guardar = () => { try { sessionStorage.setItem(CLAVE, '1') } catch { /* sin almacenamiento: se vuelve a mostrar */ } }
const dmy = (iso) => (iso ? iso.split('-').reverse().join('/') : '')

export default function AlertaStockFlotante() {
  const navigate = useNavigate()
  const [datos, setDatos] = useState(null)
  const [oculta, setOculta] = useState(leer)

  useEffect(() => {
    if (oculta) return undefined
    let vivo = true
    comedorStockApi.alertas().then((r) => vivo && setDatos(r.data.data)).catch(() => {})
    return () => { vivo = false }
  }, [oculta])

  if (oculta || !datos) return null
  const { vencidos, por_vencer: porVencer, sin_firma: sinFirma } = datos
  if (!vencidos.length && !porVencer.length && !sinFirma) return null

  const cerrar = () => { guardar(); setOculta(true) }
  // Con algo vencido o por vencer se abre el stock; si solo faltan firmas, la Entrega de mercadería.
  const ir = () => { cerrar(); navigate(`/comedores-administracion?vista=${vencidos.length || porVencer.length ? 'stock' : 'remitos'}`) }
  const grave = vencidos.length > 0

  return (
    <aside role="alertdialog" aria-labelledby="alerta-stock-titulo"
      className={`fixed bottom-4 right-4 z-[90] w-[min(24rem,calc(100vw-2rem))] rounded-2xl border-2 bg-white p-4 shadow-2xl ${grave ? 'border-rose-400' : 'border-amber-400'}`}>
      <div className="flex items-start gap-3">
        <span aria-hidden="true" className="text-2xl">{grave ? '⛔' : '⚠️'}</span>
        <div className="min-w-0 flex-1">
          <h2 id="alerta-stock-titulo" className="text-sm font-black text-ink">Alerta de stock de comedores</h2>
          <ul className="mt-1.5 space-y-1.5 text-xs font-semibold text-slate-800">
            {vencidos.length > 0 && (
              <li><strong className="text-rose-800">{vencidos.length} vencido{vencidos.length === 1 ? '' : 's'}:</strong>{' '}
                {vencidos.slice(0, 3).map((a) => `${a.nombre} (${dmy(a.vence)})`).join(', ')}{vencidos.length > 3 ? ` y ${vencidos.length - 3} más` : ''}</li>
            )}
            {porVencer.length > 0 && (
              <li><strong className="text-amber-800">{porVencer.length} por vencer en 30 días:</strong>{' '}
                {porVencer.slice(0, 3).map((a) => `${a.nombre} (${dmy(a.vence)})`).join(', ')}{porVencer.length > 3 ? ` y ${porVencer.length - 3} más` : ''}</li>
            )}
            {sinFirma > 0 && <li><strong className="text-amber-800">{sinFirma} remito{sinFirma === 1 ? '' : 's'} de entrega sin firmar</strong></li>}
          </ul>
        </div>
        <button type="button" onClick={cerrar} aria-label="Cerrar alerta" className="-mr-1 -mt-1 rounded p-1 text-lg font-black leading-none text-slate-500 hover:bg-slate-100">×</button>
      </div>
      <div className="mt-3 flex justify-end gap-2">
        <button type="button" onClick={cerrar} className="rounded-lg px-3 py-1.5 text-xs font-bold text-slate-600 hover:bg-slate-100">Más tarde</button>
        <button type="button" onClick={ir} className="btn-social px-4 py-1.5 text-xs font-black">{vencidos.length || porVencer.length ? 'Ver stock' : 'Ver remitos'}</button>
      </div>
    </aside>
  )
}
